"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Link } from "@custom/schema";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Fragment, useEffect, useState } from "react";
import { isTruthy } from "../../utils/isTruthy";
import { buildNavigationTree } from "../../utils/navigation";
var isBrowser = typeof window !== "undefined";
var localStorage = isBrowser ? window.localStorage : {
    getItem: function() {
        return null;
    },
    setItem: function() {
        return null;
    },
    removeItem: function() {
        return null;
    }
};
var userLogout = function() {
    if (document) {
        document.cookie = "drupal_user" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        document.cookie = "Drupal.visitor.drupal_user" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
    if (window) {
        localStorage.removeItem("authenticated");
        localStorage.removeItem("last_checked");
        window.location.replace("/user/logout");
    }
};
export default function Header(props) {
    var items = buildNavigationTree(props.mainNavigation.items.filter(isTruthy));
    var _useState = _sliced_to_array(useState(true), 2), focus = _useState[0], setFocus = _useState[1];
    useEffect(function() {
        var onFocus = function() {
            return setFocus(true);
        };
        var onBlur = function() {
            return setFocus(false);
        };
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        return function() {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, []);
    var _useState1 = _sliced_to_array(useState(localStorage ? localStorage.getItem("authenticated") == "1" ? true : false : false), 2), isSignedIn = _useState1[0], setIsSignedIn = _useState1[1];
    var checkUser = function() {
        var _pingUrlAndGetStatusCode = _async_to_generator(function(url) {
            var href, isUserLoginForm, now, lastChecked, hourInMs, response, statusCode, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!window) return [
                            3,
                            4
                        ];
                        href = window.location.href;
                        isUserLoginForm = href.includes("https://www.knime.com/user/login");
                        if (!isUserLoginForm) return [
                            3,
                            1
                        ];
                        localStorage.removeItem("authenticated");
                        localStorage.removeItem("last_checked");
                        setIsSignedIn(false);
                        return [
                            2
                        ];
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        now = new Date().getTime();
                        lastChecked = localStorage.getItem("last_checked");
                        hourInMs = 60 * 60 * 1000;
                        if (lastChecked && now - parseInt(lastChecked) > hourInMs) {
                            localStorage.removeItem("authenticated");
                        }
                        if (localStorage.getItem("authenticated") !== null) {
                            setIsSignedIn(localStorage.getItem("authenticated") === "1");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetch(url)
                        ];
                    case 2:
                        response = _state.sent();
                        statusCode = response.status;
                        setIsSignedIn(statusCode === 200);
                        localStorage.setItem("authenticated", statusCode === 200 ? "1" : "0");
                        localStorage.setItem("last_checked", now.toString());
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error checking user authentication:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        function pingUrlAndGetStatusCode(url) {
            return _pingUrlAndGetStatusCode.apply(this, arguments);
        }
        return pingUrlAndGetStatusCode;
    }();
    useEffect(function() {
        if (focus) {
            checkUser("/user/check");
        }
    }, [
        focus
    ]);
    var _useState2 = _sliced_to_array(useState(false), 2), isSearchOpen = _useState2[0], setIsSearchOpen = _useState2[1];
    var toggleSearch = function() {
        setIsSearchOpen(!isSearchOpen);
    };
    return /*#__PURE__*/ React.createElement("header", {
        className: "bg-white min-h-[69px] lg:min-h-[82px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl",
        "aria-label": "Global"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("fixed z-[25] top-0 left-0 lg:py-7 lg:px-8 bg-white knime-hidden lg:flex w-full", {
            "shadow-[0_2px_12px_0_rgba(0,0,0,0.1)]": !isSearchOpen
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl lg:flex items-center w-full justify-between lg:justify-start"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://www.knime.com/",
        className: "flex w-24 1.5lg:w-32 1.5xl:w-36 mr-5 xl:mr-11 focus"
    }, /*#__PURE__*/ React.createElement("img", {
        width: "122",
        height: "29",
        className: "w-24 1.5lg:w-32 1.5xl:w-36 relative -top-1.5",
        src: "/images/knime-logo.svg",
        alt: "KNIME logo"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-between items-center lg:w-full"
    }, /*#__PURE__*/ React.createElement(Popover.Group, {
        as: "nav",
        className: "knime-hidden lg:block",
        role: "navigation",
        "aria-labelledby": "mainmenulabel"
    }, /*#__PURE__*/ React.createElement("h2", {
        id: "mainmenulabel",
        className: "sr-only"
    }, "Main menu"), /*#__PURE__*/ React.createElement("ul", {
        role: "menu",
        className: "lg:flex lg:gap-x-3.5 align-ff xl:gap-x-6"
    }, items.map(function(item) {
        return item.children.length === 0 ? item.target ? /*#__PURE__*/ React.createElement("li", {
            key: item.id
        }, /*#__PURE__*/ React.createElement(Link, {
            href: item.target,
            className: "text-[0.78rem] 1.5lg:mr-1 1.5lg:text-sm relative focus font-heading font-semibold leading-6 pb-2 text-gray-900 after:transition-all after:duration-200 hover:after:w-full after:content-[''] after:block after:h-0.5 after:w-0 after:bg-yellow-500 after:absolute after:bottom-0 after:inset-x-0 after:mx-auto"
        }, item.title)) : null : /*#__PURE__*/ React.createElement(Popover, {
            as: "li",
            className: "relative mr-[22px]",
            key: item.id
        }, /*#__PURE__*/ React.createElement(Popover.Button, {
            onClick: function() {
                requestAnimationFrame(function() {
                    if (_instanceof(document.activeElement, HTMLElement)) {
                        document.activeElement.blur();
                    }
                });
            },
            className: "flex focus items-center gap-x-0.5 text-[0.78rem] 1.5lg:text-sm font-heading font-semibold leading-6 text-gray-900 after:transition-all after:duration-200 hover:after:w-full after:content-[''] after:block after:h-0.5 after:w-0 after:bg-yellow-500 after:absolute after:-bottom-1.5 after:inset-x-0 after:mx-auto"
        }, item.title, /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            className: "h-5 w-5 flex-none text-gray-100 absolute top-0.5 1.5lg:top-0 right-0 -mr-[22px]",
            "aria-hidden": "true"
        })), /*#__PURE__*/ React.createElement(Transition, {
            as: Fragment,
            enter: "transition ease-out duration-200",
            enterFrom: "opacity-0 translate-y-1",
            enterTo: "opacity-100 translate-y-0",
            leave: "transition ease-in duration-150",
            leaveFrom: "opacity-100 translate-y-0",
            leaveTo: "opacity-0 translate-y-1"
        }, /*#__PURE__*/ React.createElement(Popover.Panel, {
            as: "ul",
            className: "nav-popover absolute -left-8 top-full z-10 mt-3 w-56 bg-white px-2 py-3.5 shadow-[0_0_10px_0_rgba(0,0,0,0.1)] border-t-[3px] border-t-yellow-500"
        }, item.children.map(function(child) {
            return /*#__PURE__*/ React.createElement("li", {
                key: child.id
            }, child.target && child.target !== "/noop" ? /*#__PURE__*/ React.createElement("a", {
                href: child.target,
                className: "block px-3 focus focus-visible:outline-offset-0 text-xs font-heading font-semibold leading-6 text-gray-900 hover:bg-yellow-100"
            }, child.title) : /*#__PURE__*/ React.createElement("span", {
                className: "block px-3 text-xs font-heading font-semibold leading-6 text-gray-900"
            }, child.title), child.children.length !== 0 ? /*#__PURE__*/ React.createElement("ul", {
                className: "mt-1 mb-2 pb-1 ml-5 border-b border-b-gray-10"
            }, child.children.map(function(grandchild) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: grandchild.id
                }, grandchild.target ? /*#__PURE__*/ React.createElement(Link, {
                    href: grandchild.target,
                    className: "text-gray-200 focus-white hover:underline transition-all text-xxs block leading-relaxed mb-1"
                }, grandchild.title) : null);
            })) : null);
        }))));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "knime-hidden lg:flex items-center gap-x-2 1.5lg:gap-x-3"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "mr-1",
        onClick: toggleSearch,
        "aria-label": "Open Search Bar"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30px",
        height: "30px",
        viewBox: "0 0 30 30",
        version: "1.1"
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Nav Search/Static"), /*#__PURE__*/ React.createElement("g", {
        id: "Nav-Search:-Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage:-Search-Static",
        transform: "translate(-1040.000000, -35.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Buttons",
        transform: "translate(1040.000000, 33.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Nav-Search/Static",
        transform: "translate(0.000000, 2.000000)"
    }, /*#__PURE__*/ React.createElement("circle", {
        id: "Outline",
        stroke: "#F0F2F2",
        fill: "#F7F9FB",
        cx: "15",
        cy: "15",
        r: "14.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.399973,19.8 C17.3822957,19.8 19.799946,17.3823376 19.799946,14.4 C19.799946,11.4176624 17.3822957,9 14.399973,9 C11.4176503,9 9,11.4176624 9,14.4 C9,17.3823376 11.4176503,19.8 14.399973,19.8 Z M18.2445738,18.24432 L21,21",
        id: "Icon",
        stroke: "#6F6F6F",
        strokeWidth: "2"
    })))))), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Search")), props.metaNavigation.items.filter(isTruthy).map(function(item, key) {
        return /*#__PURE__*/ React.createElement(NavButtons, {
            buttonItem: item,
            key: key
        });
    }), isSignedIn === true ? /*#__PURE__*/ React.createElement(Popover, {
        className: "relative ml-px"
    }, /*#__PURE__*/ React.createElement(Popover.Button, {
        className: "focus relative top-[3px]",
        onClick: function() {
            requestAnimationFrame(function() {
                if (_instanceof(document.activeElement, HTMLElement)) {
                    document.activeElement.blur();
                }
            });
        }
    }, /*#__PURE__*/ React.createElement("img", {
        width: "24",
        height: "24",
        className: "w-6",
        src: "/images/icon-user_static.png",
        onMouseOver: function(e) {
            return e.currentTarget.src = "/images/icon-user_hover.png";
        },
        onMouseOut: function(e) {
            return e.currentTarget.src = "/images/icon-user_static.png";
        },
        alt: "User icon"
    })), /*#__PURE__*/ React.createElement(Popover.Panel, {
        as: "ul",
        className: "nav-popover absolute -left-9 top-full z-10 mt-3 bg-white px-2 py-3.5 shadow-[0_0_10px_0_rgba(0,0,0,0.1)]"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "/user-settings",
        className: "block px-3 focus focus-visible:outline-offset-0 text-xs font-heading font-semibold leading-6 text-gray-900 hover:bg-yellow-100"
    }, "Settings")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        onClick: userLogout,
        className: "cursor-pointer block px-3 focus focus-visible:outline-offset-0 text-xs font-heading font-semibold leading-6 text-gray-900 hover:bg-yellow-100"
    }, "Sign out")))) : /*#__PURE__*/ React.createElement("a", {
        href: "/user/login",
        className: "button-plain button-sign-in hover:text-gray-100 focus text-[0.78rem] 1.5lg:text-sm text-black lg:text-gray-100 group w-full lg:w-auto flex items-center lg:justify-center md:ml-1 border-t border-t-[#F0F2F2] lg:border-none mt-9 lg:mt-0 pt-7 lg:pt-0"
    }, /*#__PURE__*/ React.createElement("span", null, "Sign in")))))), /*#__PURE__*/ React.createElement(SearchBar, {
        isSearchOpen: isSearchOpen,
        setIsSearchOpen: setIsSearchOpen,
        className: "knime-hidden lg:block"
    }), /*#__PURE__*/ React.createElement(MobileHeader, _object_spread_props(_object_spread({}, props), {
        isSignedIn: isSignedIn
    }))));
}
function SearchBar(param) {
    var isSearchOpen = param.isSearchOpen, setIsSearchOpen = param.setIsSearchOpen, className = param.className;
    var _useState = _sliced_to_array(useState(""), 2), searchQuery = _useState[0], setSearchQuery = _useState[1];
    var handleInputChange = function(e) {
        setSearchQuery(e.target.value);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("pt-8 mt-8 lg:mt-0 lg:py-6 lg:px-4 lg:fixed lg:z-[24] transition-all border-t-2 border-t-gray-10 lg:border-t-gray-400 w-full top-1 1.5lg:top-1.5 left-0 lg:bg-white lg:shadow-[0_2px_12px_0_rgba(0,0,0,0.07)]", {
            "lg:translate-y-full lg:opacity-100": isSearchOpen,
            "lg:-translate-y-full lg:opacity-0": !isSearchOpen
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:max-w-4xl lg:mx-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex relative items-center"
    }, /*#__PURE__*/ React.createElement("button", {
        className: "absolute top-2 left-2.5 lg:left-2 w-3.5 z-10",
        onClick: function() {
            return setIsSearchOpen(true);
        }
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        className: "w-3.5"
    }, /*#__PURE__*/ React.createElement("title", null, "Icon"), /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Nav-Search/Tablet/Hover",
        transform: "translate(-9.000000, -9.000000)",
        stroke: "#6F6F6F",
        strokeWidth: "2"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.2999685,22.6 C19.779345,22.6 22.599937,19.7793939 22.599937,16.3 C22.599937,12.8206061 19.779345,10 16.2999685,10 C12.820592,10 10,12.8206061 10,16.3 C10,19.7793939 12.820592,22.6 16.2999685,22.6 Z M20.7853361,20.78504 L24,24",
        id: "Icon"
    }))))), /*#__PURE__*/ React.createElement("form", {
        action: "/search",
        method: "GET",
        className: clsx("relative max-[1023px]:transition-all", {
            "w-full sm:w-1/2 lg:w-full": isSearchOpen,
            "w-[30px]": !isSearchOpen
        })
    }, /*#__PURE__*/ React.createElement("input", {
        type: "text",
        placeholder: "Search...",
        name: "q",
        value: searchQuery,
        onChange: handleInputChange,
        "aria-label": "Search",
        className: clsx("rounded-full bg-gray-10 border-[#eee] w-full text-xs lg:w-full pl-8 transition-all focus:ring-0 focus-visible:border-black", {
            "pr-12": isSearchOpen,
            "max-[1023px]:pr-0": !isSearchOpen
        })
    }), /*#__PURE__*/ React.createElement("button", {
        type: "submit",
        className: clsx("block absolute top-[5px] lg:hidden transition-all", {
            "right-2 opacity-100": isSearchOpen,
            "right-20 opacity-0": !isSearchOpen
        })
    }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
        className: "w-6 h-6 text-gray-200"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Search"))), /*#__PURE__*/ React.createElement("button", {
        onClick: function() {
            return setIsSearchOpen(false);
        },
        "aria-label": "Close Search Bar",
        className: "knime-hidden lg:block"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "h-7 w-7 ml-5",
        "aria-hidden": "true"
    })))));
}
function MobileHeader(props) {
    var items = buildNavigationTree(props.mainNavigation.items.filter(isTruthy));
    var _useState = _sliced_to_array(useState(false), 2), isSearchOpen = _useState[0], setIsSearchOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isMenuOpen = _useState1[0], setIsMenuOpen = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), isLevelOpen = _useState2[0], setIsLevelOpen = _useState2[1];
    var _useState3 = _sliced_to_array(useState(true), 2), isSecondLevelOpen = _useState3[0], setIsSecondLevelOpen = _useState3[1];
    useEffect(function() {
        if (isMenuOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }
        return function() {
            document.body.classList.remove("overflow-hidden");
        };
    }, [
        isMenuOpen
    ]);
    return /*#__PURE__*/ React.createElement(Popover, {
        className: "menu-panel block lg:hidden"
    }, function(param) {
        var open = param.open;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: "fixed z-[25] top-0 left-0 px-6 pt-6 pb-4 bg-white shadow-[0_2px_12px_0_rgba(0,0,0,0.1)] flex items-center w-full justify-between lg:justify-start"
        }, /*#__PURE__*/ React.createElement("a", {
            href: "https://www.knime.com/",
            className: "flex w-28 mr-7 xl:mr-11 focus"
        }, /*#__PURE__*/ React.createElement("img", {
            width: "122",
            height: "29",
            className: "w-28 relative -top-1.5",
            src: "/images/knime-logo.svg",
            alt: "KNIME logo"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "flex justify-between items-center lg:w-full"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex lg:hidden relative -top-1"
        }, /*#__PURE__*/ React.createElement(Popover.Button, {
            type: "button",
            className: "-m-2.5 focus inline-flex items-center justify-center p-2.5 text-gray-700",
            onClick: function() {
                return setIsMenuOpen(true);
            }
        }, /*#__PURE__*/ React.createElement("span", {
            className: "sr-only"
        }, "Open main menu"), /*#__PURE__*/ React.createElement(Bars3Icon, {
            className: "h-7 w-7",
            "aria-hidden": "true"
        }))))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Transition, {
            enter: "transition duration-400 ease-out",
            enterFrom: "transform translate-x-full opacity-0",
            enterTo: "transform translate-x-0 opacity-100",
            leave: "transition duration-400 ease-out",
            leaveFrom: "transform translate-x-0 opacity-100",
            leaveTo: "transform translate-x-full opacity-0",
            className: "fixed p-6 top-0 min-h-screen right-0 w-full h-screen overflow-y-auto z-30 bg-white"
        }, /*#__PURE__*/ React.createElement(Popover.Panel, {
            className: ""
        }, function(param) {
            var close = param.close;
            return /*#__PURE__*/ React.createElement("nav", {
                role: "navigation",
                "aria-labelledby": "mobilemenulabel"
            }, /*#__PURE__*/ React.createElement(MobileMenuHeader, {
                open: open,
                close: close,
                setIsMenuOpen: setIsMenuOpen,
                setIsLevelOpen: setIsLevelOpen
            }), /*#__PURE__*/ React.createElement("h2", {
                id: "mobilemenulabel",
                className: "sr-only"
            }, "Mobile menu"), /*#__PURE__*/ React.createElement("ul", {
                role: "menu",
                className: "pt-7"
            }, items.map(function(item) {
                return item.children.length === 0 ? item.target ? /*#__PURE__*/ React.createElement("li", {
                    key: item.id
                }, /*#__PURE__*/ React.createElement(Link, {
                    key: item.title,
                    href: item.target,
                    className: "-mx-3 block py-3 pl-2 pr-1 text-sm font-heading font-semibold leading-7 text-gray-900"
                }, item.title)) : null : /*#__PURE__*/ React.createElement("li", {
                    className: "-mx-3",
                    key: item.id
                }, /*#__PURE__*/ React.createElement(Popover, null, /*#__PURE__*/ React.createElement(Popover.Button, {
                    onClick: function() {
                        return setIsLevelOpen(false);
                    },
                    className: "flex focus w-full items-center justify-between py-3 pl-2 text-sm font-heading font-semibold leading-7"
                }, item.title, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                    className: "h-6 w-6 flex-none",
                    "aria-hidden": "true"
                })), /*#__PURE__*/ React.createElement(Transition, {
                    enter: "transition duration-400 ease-out",
                    enterFrom: "transform translate-x-full opacity-0",
                    enterTo: "transform translate-x-0 opacity-100",
                    leave: "transition duration-400 ease-out",
                    leaveFrom: "transform translate-x-0 opacity-100",
                    leaveTo: "transform translate-x-full opacity-0",
                    className: "bg-white w-full fixed top-0 left-0 min-h-screen h-full z-[31]"
                }, /*#__PURE__*/ React.createElement(Popover.Panel, {
                    className: "sub-menu bg-white block"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "p-6 mb-2"
                }, /*#__PURE__*/ React.createElement(MobileMenuHeader, {
                    close: close,
                    setIsMenuOpen: setIsMenuOpen,
                    setIsLevelOpen: setIsLevelOpen
                })), /*#__PURE__*/ React.createElement(Popover.Button, {
                    onClick: function() {
                        return setIsLevelOpen(true);
                    },
                    className: "flex focus relative w-full items-center py-2 pl-9 pr-3.5 text-base mb-2 font-heading font-semibold leading-7"
                }, /*#__PURE__*/ React.createElement(ChevronLeftIcon, {
                    className: "h-6 w-6 mr-1 flex-none absolute left-2 top-2.5",
                    "aria-hidden": "true"
                }), item.title), /*#__PURE__*/ React.createElement("ul", null, item.children.map(function(child) {
                    return child.children.length !== 0 ? /*#__PURE__*/ React.createElement("li", {
                        key: child.id
                    }, /*#__PURE__*/ React.createElement(Popover, null, /*#__PURE__*/ React.createElement(Popover.Button, {
                        onClick: function() {
                            return setIsSecondLevelOpen(false);
                        },
                        className: "flex focus w-full items-center justify-between py-3 pl-9 pr-3 text-sm font-heading font-semibold leading-7"
                    }, child.title, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                        className: "h-6 w-6 flex-none",
                        "aria-hidden": "true"
                    })), /*#__PURE__*/ React.createElement(Transition, {
                        enter: "transition duration-400 ease-out",
                        enterFrom: "transform translate-x-full opacity-0",
                        enterTo: "transform translate-x-0 opacity-100",
                        leave: "transition duration-400 ease-out",
                        leaveFrom: "transform translate-x-0 opacity-100",
                        leaveTo: "transform translate-x-full opacity-0",
                        className: "bg-white w-full fixed top-0 left-0 min-h-screen h-full z-[32]"
                    }, /*#__PURE__*/ React.createElement(Popover.Panel, {
                        className: "sub-menu bg-white"
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: "p-6 mb-2"
                    }, /*#__PURE__*/ React.createElement(MobileMenuHeader, {
                        close: close,
                        setIsMenuOpen: setIsMenuOpen,
                        setIsLevelOpen: setIsLevelOpen
                    })), /*#__PURE__*/ React.createElement(Popover.Button, {
                        onClick: function() {
                            return setIsSecondLevelOpen(true);
                        },
                        className: "flex focus relative w-full items-center py-2 pl-9 pr-3.5 text-base mb-2 font-heading font-semibold leading-7"
                    }, /*#__PURE__*/ React.createElement(ChevronLeftIcon, {
                        className: "h-6 w-6 mr-1 flex-none absolute left-2 top-2.5",
                        "aria-hidden": "true"
                    }), child.title), /*#__PURE__*/ React.createElement("ul", null, child.children.map(function(grandchild) {
                        return /*#__PURE__*/ React.createElement("li", {
                            key: grandchild.id
                        }, grandchild.target ? /*#__PURE__*/ React.createElement(Link, {
                            href: grandchild.target,
                            className: "block focus py-2 pl-9 pr-3 text-sm font-heading font-semibold leading-7 text-gray-900"
                        }, grandchild.title) : null);
                    })), /*#__PURE__*/ React.createElement("div", {
                        className: "px-7 mt-5 -mx-3"
                    }, props.metaNavigation.items.filter(isTruthy).map(function(item, key) {
                        return /*#__PURE__*/ React.createElement(NavButtons, {
                            buttonItem: item,
                            key: key
                        });
                    }), /*#__PURE__*/ React.createElement(UserMenu, {
                        isSignedIn: props.isSignedIn
                    }), /*#__PURE__*/ React.createElement(SearchBar, {
                        isSearchOpen: isSearchOpen,
                        setIsSearchOpen: setIsSearchOpen
                    })))))) : /*#__PURE__*/ React.createElement("li", {
                        key: child.id
                    }, /*#__PURE__*/ React.createElement("a", {
                        href: child.target,
                        className: "block focus py-2 pl-9 pr-3 text-sm font-heading font-semibold leading-7 text-gray-900"
                    }, child.title));
                })), /*#__PURE__*/ React.createElement("div", {
                    className: clsx("px-7 mt-5 -mx-3", {
                        "opacity-0": !isSecondLevelOpen
                    })
                }, props.metaNavigation.items.filter(isTruthy).map(function(item, key) {
                    return /*#__PURE__*/ React.createElement(NavButtons, {
                        buttonItem: item,
                        key: key
                    });
                }), /*#__PURE__*/ React.createElement(UserMenu, {
                    isSignedIn: props.isSignedIn
                }), /*#__PURE__*/ React.createElement(SearchBar, {
                    isSearchOpen: isSearchOpen,
                    setIsSearchOpen: setIsSearchOpen
                }))))));
            })), /*#__PURE__*/ React.createElement("div", {
                className: clsx("px-1.5 mt-6 -mx-3", {
                    "opacity-0": !isLevelOpen
                })
            }, props.metaNavigation.items.filter(isTruthy).map(function(item, key) {
                return /*#__PURE__*/ React.createElement(NavButtons, {
                    buttonItem: item,
                    key: key
                });
            }), /*#__PURE__*/ React.createElement(UserMenu, {
                isSignedIn: props.isSignedIn
            }), /*#__PURE__*/ React.createElement(SearchBar, {
                isSearchOpen: isSearchOpen,
                setIsSearchOpen: setIsSearchOpen
            })));
        }))));
    });
}
function MobileMenuHeader(param) {
    var close = param.close, setIsMenuOpen = param.setIsMenuOpen, setIsLevelOpen = param.setIsLevelOpen;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://www.knime.com/",
        className: "-m-1.5 p-1.5 focus"
    }, /*#__PURE__*/ React.createElement("img", {
        width: "122",
        height: "29",
        className: "w-28 relative -top-1.5",
        src: "/images/knime-logo.svg",
        alt: "KNIME logo"
    })), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "-m-2.5 p-2.5 text-gray-700 focus",
        onClick: function() {
            close();
            setIsMenuOpen(false);
            setIsLevelOpen(true);
        }
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Close menu"), /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "h-6 w-6",
        "aria-hidden": "true"
    })));
}
function NavButtons(param) {
    var buttonItem = param.buttonItem, key = param.key;
    return /*#__PURE__*/ React.createElement("a", {
        key: key,
        href: buttonItem.target,
        className: clsx("", {
            "button-primary bg-orange-500 focus px-3 1.5lg:px-4 py-1.5 text-[0.78rem] w-[calc(50%-0.75rem)] md:min-w-[150px] lg:min-w-[unset] md:w-auto ml-3 lg:mx-0 1.5lg:text-sm text-white hover:text-white hover:bg-orange-600": buttonItem.display === "PRIMARY",
            "button-secondary border-gray-600 focus px-3 1.5lg:px-4 py-1.5 text-[0.78rem] w-[calc(50%-0.75rem)] md:min-w-[150px] lg:min-w-[unset] md:w-auto mr-3 lg:mx-0 1.5lg:text-sm text-gray-100 hover:bg-gray-600 hover:text-white": buttonItem.display === "SECONDARY",
            "button-plain button-sign-in hover:text-gray-100 focus text-[0.78rem] 1.5lg:text-sm text-black lg:text-gray-100 group w-full lg:w-auto flex items-center lg:justify-center md:ml-1 border-t border-t-[#F0F2F2] lg:border-none mt-9 lg:mt-0 pt-7 lg:pt-0": buttonItem.display === "PLAIN"
        })
    }, buttonItem.display !== "PLAIN" ? buttonItem.label : /*#__PURE__*/ React.createElement("span", null, buttonItem.label));
}
function UserMenu(param) {
    var isSignedIn = param.isSignedIn;
    return isSignedIn === true ? /*#__PURE__*/ React.createElement("ul", {
        className: "flex justify-between border-t border-t-[#F0F2F2] lg:border-none mt-9 lg:mt-0 pt-6 lg:pt-0"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        href: "/user-settings",
        className: "button-plain focus text-[0.78rem] 1.5lg:text-sm text-gray-100 lg:text-gray-100 group w-full lg:w-auto flex items-center lg:justify-center md:ml-1"
    }, "Settings")), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("a", {
        onClick: userLogout,
        className: "cursor-pointer button-plain focus text-[0.78rem] 1.5lg:text-sm text-gray-100 lg:text-gray-100 group w-full lg:w-auto flex items-center lg:justify-center md:ml-1"
    }, "Sign out"))) : /*#__PURE__*/ React.createElement("a", {
        href: "/user/login",
        className: "button-plain button-sign-in hover:text-gray-100 focus text-[0.78rem] 1.5lg:text-sm text-black lg:text-gray-100 group w-full lg:w-auto flex items-center lg:justify-center md:ml-1 border-t border-t-[#F0F2F2] lg:border-none mt-9 lg:mt-0 pt-7 lg:pt-0"
    }, /*#__PURE__*/ React.createElement("span", null, "Sign in"));
}
